<!--互联互通 添加/编辑form表单-->
<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            {{ form.id ? form.name : "添加" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form
                label-width="8em"
                :model="form"
                ref="form"
                :style="{ color: theme.pageFontColor }"
            >
                <el-form-item label="公司名称" :rules="[{ required: true }]">
                    <el-input
                        type="text"
                        v-model="form.name"
                        placeholder="公司中文名/简称"
                        clearable
                    >
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="共享站点" :rules="[{ required: true }]">
                    <select-site
                        v-if="isSite"
                        :width="'100%'"
                        :selectSite="form.station_ids"
                        @choose="choose"
                        :multiple="multiple"
                        :isCaotact="isCaotact"
                        :isAll="isAll"
                    />
                </el-form-item>
                <div align="center">
                    <h4 class="mb-3">{{ form.name ? form.name : "对接公司" }}</h4>
                    <el-form-item label="运营商ID" :rules="[{ required: true }]">
                        <el-input
                            type="text"
                            v-model="form.operator_id"
                            placeholder="对接运营商ID"
                            clearable
                        >
                            <i class="el-icon-edit" slot="prepend"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="对接URL" :rules="[{ required: true }]">
                        <el-input
                            type="text"
                            v-model="form.url"
                            placeholder="对接公司提供的对接URL"
                            clearable
                        >
                            <i class="el-icon-edit" slot="prepend"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="消息Data密钥" :rules="[{ required: true }]">
                        <el-input type="text" v-model="form.data_secret" clearable show-password>
                            <i class="el-icon-edit" slot="prepend"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="消息Data密钥向量" :rules="[{ required: true }]">
                        <el-input type="text" clearable v-model="form.data_secret_iv" show-password>
                            <i class="el-icon-edit" slot="prepend"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="运营商密钥" :rules="[{ required: true }]">
                        <el-input
                            type="text"
                            v-model="form.operator_secret"
                            clearable
                            show-password
                        >
                            <i class="el-icon-edit" slot="prepend"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="签名密钥" :rules="[{ required: true }]">
                        <el-input type="text" v-model="form.sig_secret" clearable show-password>
                            <i class="el-icon-edit" slot="prepend"></i>
                        </el-input>
                    </el-form-item>
                </div>
                <v-divider inset class="pt-3 pb-3"></v-divider>
                <div align="center">
                    <h4 class="mb-3">美森信息</h4>
                    <el-form-item label="运营商ID" :rules="[{ required: true }]">
                        <el-input
                            type="text"
                            v-model="form.my_operator_id"
                            placeholder="运营商ID"
                            clearable
                        >
                            <i class="el-icon-edit" slot="prepend"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="消息Data密钥" :rules="[{ required: true }]">
                        <el-input type="text" v-model="form.my_data_secret" clearable show-password>
                            <i class="el-icon-edit" slot="prepend"></i>
                            <el-button
                                v-if="!form.my_data_secret"
                                slot="append"
                                @click="obtainSecret(32, 'data_secret')"
                            >
                                获取
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="消息Data密钥向量" :rules="[{ required: true }]">
                        <el-input
                            type="text"
                            v-model="form.my_data_secret_iv"
                            show-password
                            clearable
                        >
                            <i class="el-icon-edit" slot="prepend"></i>
                            <el-button
                                v-if="!form.my_data_secret_iv"
                                slot="append"
                                @click="obtainSecret(16, 'data_secret_iv')"
                            >
                                获取
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="运营商密钥" :rules="[{ required: true }]">
                        <el-input
                            type="text"
                            v-model="form.my_operator_secret"
                            show-password
                            clearable
                        >
                            <i class="el-icon-edit" slot="prepend"></i>
                            <el-button
                                v-if="!form.my_operator_secret"
                                slot="append"
                                @click="obtainSecret(32, 'operator_secret')"
                            >
                                获取
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="签名密钥" :rules="[{ required: true }]">
                        <el-input type="text" v-model="form.my_sig_secret" clearable show-password>
                            <i class="el-icon-edit" slot="prepend"></i>
                            <el-button
                                v-if="!form.my_sig_secret"
                                slot="append"
                                @click="obtainSecret(32, 'sig_secret')"
                            >
                                获取
                            </el-button>
                        </el-input>
                    </el-form-item>
                </div>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="apply()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import util from "@/util";
import Public from "@/public"
import store from "@/store";
import SelectSite from "@/components/SelectSite";
import { mapState } from "vuex";
export default {
    data() {
        return {
            isSite: true,
            isCaotact: true, // 是否为互联互通页面
            isAll: false, //是否选择全部站点
            multiple: true, //是否多选站点
            siteName: [], //选中的站点名称
            form: {
                id: null,
                operator_id: null, //对接公司运营商ID
                my_operator_id: null, //我的运营商ID
                name: null, //公司名称
                url: null, //对接URL
                station_ids: null, //站点  [] 不共享站点；null 全部站点
                data_secret_iv: null, //对接公司消息Data密钥向量
                operator_secret: null, //对接公司运营商密钥
                data_secret: null, //对接公司消息Data密钥
                sig_secret: null, //对接公司签名密钥
                my_data_secret_iv: null, //本公司消息Data密钥向量
                my_operator_secret: null, //本公司运营商密钥
                my_data_secret: null, //本公司消息Data密钥
                my_sig_secret: null, //本公司签名密钥
            },
        };
    },
    mounted() {
        if (this.isAddSite) {
            return;
        }
        Object.keys(this.form).forEach(key => {
            if (key == "station_ids") {
                if (
                    (this.contactData["station_ids"] != undefined &&
                        this.contactData["station_ids"].length) == 0
                ) {
                    this.multiple = false;
                    this.form["station_ids"] = -1;
                } else if (
                    this.contactData["station_ids"] != undefined &&
                    this.contactData["station_ids"] == null
                ) {
                    this.multiple = false;
                    this.form["station_ids"] = -2;
                    this.isAll = true;
                } else {
                    this.form[key] = this.contactData[key];
                }
            } else {
                this.form[key] = this.contactData[key];
            }
        });
    },
    props: {
        contactData: Object,
        isAddSite: Boolean,
    },
    watch: {
        form() {
            this.isSite = false;
            this.$nextTick(() => {
                this.isSite = true;
            });
        },
    },
    components: {
        SelectSite,
    },
    computed: {
        ...mapState(["theme", "contactInfo"]),
    },
    methods: {
        effective(e) {
            if (e == 0) {
                return "是";
            } else {
                return "否";
            }
        },
        dataState(e) {
            if (e == 0) {
                return "正常";
            } else {
                return "错误";
            }
        },
        /*确定*/
        apply() {
            let params = {
                postData: { cecInfo: {} },
                callback: () => {
                    this.$emit("refresh");
                    this.cancel();
                },
            };
            let form = Object.assign({}, this.form);
            if (this.isAddSite) {
                delete form.id;
            }
            let arr;
            if ((arr = Object.keys(form).filter(key => !form[key])).length <= 0) {
                Object.keys(this.form).forEach(key => {
                    if (key === "id") {
                        params.postData.cecInfo[key] = this.form[key];
                    } else if (key === "station_ids") {
                        if (this.form[key] == -1) {
                            params.postData.cecInfo[key] = [];
                        } else if (this.isAll) {
                            params.postData.cecInfo[key] = null;
                        } else {
                            params.postData.cecInfo[key] = this.form[key];
                        }
                    } else {
                        params.postData.cecInfo[key] = Public.removeSpace(this.form[key]);
                    }
                });
            } else {
                util.ShowTip("必填项不能为空", 3);
                return;
            }
            if (this.isAddSite) {
                store.dispatch("addConnact", params);
            } else {
                store.dispatch("updateConnact", params);
            }
        },
        /*取消添加*/
        cancel() {
            if (this.isCaotact) {
                this.isCaotact = false;
            }
            this.$emit("cancel");
        },
        /*选择站点*/
        choose(site) {
            if (site.isSpecial) {
                this.multiple = false;
                this.form.station_ids = site.siteId;
            } else {
                this.multiple = true;
                let siteData = this.JsonData(site);
                this.form.station_ids = siteData.siteIds;
                if (siteData.isAll) {
                    this.isAll = siteData.isAll;
                }
            }
        },
        /*判断两个值是否相等*/
        isSame(string1, arrs, len, name) {
            for (let i = 0; i < arrs.length; i++) {
                if (string1 == arrs[i][name]) {
                    this.isSame(this.obtain(len), arrs, len, name);
                }
            }
            return string1;
        },
        /*获取密钥*/
        obtainSecret(len, data) {
            if (data == "data_secret") {
                let data_secret = this.isSame(
                    this.obtain(len),
                    this.contactInfo,
                    len,
                    "data_secret"
                );
                this.form.my_data_secret = data_secret;
            }
            if (data == "data_secret_iv") {
                let data_secret_iv = this.isSame(
                    this.obtain(len),
                    this.contactInfo,
                    len,
                    "data_secret_iv"
                );
                this.form.my_data_secret_iv = data_secret_iv;
            }
            if (data == "operator_secret") {
                let operator_secret = this.isSame(
                    this.obtain(len),
                    this.contactInfo,
                    len,
                    "operator_secret"
                );
                this.form.my_operator_secret = operator_secret;
            }
            if (data == "sig_secret") {
                let sig_secret = this.isSame(this.obtain(len), this.contactInfo, len, "sig_secret");
                this.form.my_sig_secret = sig_secret;
            }
        },
        /*随机获取*/
        obtain(len) {
            let charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let randomString = "";
            for (var i = 0; i < len; i++) {
                let randomPoz = Math.floor(Math.random() * charSet.length);
                randomString += charSet.substring(randomPoz, randomPoz + 1);
            }
            return randomString;
        },
        /*去除左右空格*/
        trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
};
</script>
